// extracted by mini-css-extract-plugin
export var closeButton = "_l6-1";
export var closeX = "_l6-3";
export var container = "_l6-0";
export var image = "_l6-2";